import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES HYUNDAI COLOMBIA S.A.S.</h1>
  );
};

export default TitleComponent;
